const API_PATH = process.env.REACT_APP_API_URL || "/api/v1";
export default API_PATH;
